<script>
import { mapGetters } from 'vuex';
import EvaluationApi from '@/api/evaluation';

export default {
  name: 'QuestionnaireSatisfaction',
  props: {
    numeroCommande: {
      type: String,
      default: null
    }
  },
  data: () => ({
    sending: false,
    sent: false,
    form: {
      notes: {
        globale: null,
        design: null,
        fluidite: null,
        lisibilite: null,
        navigation: null
      },
      commentaire: null
    }
  }),
  computed: {
    ...mapGetters({ numTiers: 'user/numTiers' })
  },
  beforeDestroy () {
    this.autoSendBeforeQuit();
  },
  created () {
    window.addEventListener('beforeunload', this.beforeunloadHandler);
  },
  methods: {
    beforeunloadHandler () {
      this.autoSendBeforeQuit();
    },
    autoSendBeforeQuit () {
      if (!this.sending && !this.sent && this.form.notes.globale !== null) {
        this.send();
      }
    },
    send () {
      window.removeEventListener('beforeunload', this.beforeunloadHandler);
      const data = {
        numTiers: this.numTiers,
        numeroCommande: this.numeroCommande,
        questionnaire: this.form
      };

      this.sending = true;
      EvaluationApi.envoyerEvaluation(data).finally(() => {
        this.sending = false;
        this.sent = true;
      });
    }
  }
};
</script>

<template>
  <div class="questionnaire">
    <div v-if="sent">
      Merci de votre retour.
    </div>
    <div v-else-if="sending">
      <Loader inline />
    </div>
    <div
      v-else
      class="form"
    >
      <div />
      <div class="form-row">
        <span class="label"> Votre avis nous intéresse :</span>
        <v-rating
          v-model="form.notes.globale"
          empty-icon="mdi-star-outline"
          full-icon="mdi-star"
          half-icon="mdi-star-half-full"
          half-increments
          background-color="primary"
          hover
          length="5"
          size="35"
        />
      </div>
      <div v-if="form.notes.globale !== null">
        <div class="mt-9 mb-5">
          Voulez-vous nous donner plus de détails ?
        </div>
        <div class="form-row">
          <span class="label">Design du site :</span>
          <v-rating
            v-model="form.notes.design"
            empty-icon="mdi-star-outline"
            full-icon="mdi-star"
            half-icon="mdi-star-half-full"
            half-increments
            background-color="primary"
            hover
            length="5"
            size="35"
          />
        </div>
        <div class="form-row">
          <span class="label">Fluidité d'affichage :</span>
          <v-rating
            v-model="form.notes.fluidite"
            empty-icon="mdi-star-outline"
            full-icon="mdi-star"
            half-icon="mdi-star-half-full"
            half-increments
            background-color="primary"
            hover
            length="5"
            size="35"
          />
        </div>
        <div class="form-row">
          <span class="label">Lisibilité des informations :</span>
          <v-rating
            v-model="form.notes.lisibilite"
            empty-icon="mdi-star-outline"
            full-icon="mdi-star"
            half-icon="mdi-star-half-full"
            half-increments
            background-color="primary"
            hover
            length="5"
            size="35"
          />
        </div>
        <div class="form-row">
          <span class="label">Navigation :</span>
          <v-rating
            v-model="form.notes.navigation"
            empty-icon="mdi-star-outline"
            full-icon="mdi-star"
            half-icon="mdi-star-half-full"
            half-increments
            background-color="primary"
            hover
            length="5"
            size="35"
          />
        </div>
        <div class="form-row">
          <v-textarea
            v-model="form.commentaire"
            maxlength="1000"
            background-color="#f2f2f2"
            label="Commentaire"
            placeholder="Vos attentes, des améliorations à apporter ?"
          />
        </div>
        <div class="form-row">
          <div class="spacer" />
          <v-btn @click="send">
            Envoyer <v-icon>mdi-chevron-double-right</v-icon>
          </v-btn>
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.questionnaire{
  font-size: 24px;
}
.form-row{
  display: flex;
  flex-direction: row;
  align-items: center;
  flex-wrap: wrap;
  justify-content: space-between;
}
@media #{map-get($display-breakpoints, 'xs-only')} {
  span.label{
    display: block;
    width: 100%;
  }
}
.spacer{
  flex-grow: 1;
}
</style>
